import { has } from 'lodash-es';

export const arrayToObject = (
  arr: any[], keyField: string, singleProp: string = '',
) => Object.assign({}, ...arr.map((item) => ({
  [has(item, keyField) ? item[keyField] : keyField]: singleProp ? item[singleProp] : item,
})));
